import * as React from 'react';
import { UIText1 } from '@cian/ui-kit/typography';

import { NoLayoutImage } from './NoLayoutImage';
import * as styles from './styles.css';
import { ILayoutData } from '../../../../types/offers';
import { HoveredLink } from '../../../HoveredLink';

type TOfferLayoutRowProps = Omit<ILayoutData, 'offerId' | 'houseName' | 'gaLabel'> & {
  houseName?: string;
  onLinkClick(): void;
};

export function OfferLayoutRow({
  offerUrl,
  roomCount,
  houseName,
  finishDate,
  totalArea,
  priceDisplay,
  layoutImageUrl,
  onLinkClick,
}: TOfferLayoutRowProps) {
  return (
    <div className={styles['container']}>
      <div className={styles['room-count']}>
        <HoveredLink url={offerUrl} onClick={onLinkClick}>
          {roomCount}
        </HoveredLink>
      </div>
      {houseName && (
        <div className={styles['house-name']}>
          <UIText1 color="gray60_100">{houseName}</UIText1>
        </div>
      )}
      <div className={styles['finish-date']}>
        <UIText1 color="gray60_100">{finishDate}</UIText1>
      </div>
      <div className={styles['area']}>
        <UIText1 color="gray60_100">{totalArea}</UIText1>
      </div>
      <div className={styles['price']}>
        <UIText1 color="text-primary-default">{priceDisplay}</UIText1>
      </div>
      <div className={styles['layout-image']} style={{ backgroundImage: `url(${layoutImageUrl})` }}>
        {!layoutImageUrl && <NoLayoutImage />}
      </div>
    </div>
  );
}
